//#region src/compound_mod_group_type.ts
let CompoundModGroupType = /* @__PURE__ */ function(CompoundModGroupType) {
	CompoundModGroupType["MergeRemoveRegularExtraMods"] = "merge-remove-regular-extra-mods";
	return CompoundModGroupType;
}({});
//#endregion
export { CompoundModGroupType };

//# sourceMappingURL=compound_mod_group_type.js.map